'use client';

import type { ApiError } from '@/app/hooks/useError';
import { VpButton, VpIcon } from '@vtmn-play/react/headless';
import { useTranslations } from 'next-intl';
import { useEffect, useMemo, useState } from 'react';
import { useApiErrorContext } from '@/app/components/Provider';
import { ErrorInfosDisconnect } from './ErrorInfosDisconect';

export function ErrorInfos({ error: baseError }: { error?: Partial<ApiError> }) {
  const tDialog = useTranslations('ERROR_DIALOG');
  const tMessage = useTranslations('ERROR_MESSAGE');

  const { error, status, setError } = useApiErrorContext();

  const [isOpen, setIsOpen] = useState(false);

  const title = useMemo(() => {
    switch (status) {
      case 401:
        return tMessage('AUTHORIZATION');
      case 403:
        return tMessage('FORBIDDEN');
      case 500:
        return tMessage('NETWORK');
      default:
        return error?.['hydra:title'];
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  useEffect(() => {
    if (baseError) {
      setError(baseError);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="error__wrapper">
      <div className="text-center">
        <p className="vp-title-s">{title}</p>

        {status === 403 && <ErrorInfosDisconnect />}

        {![401, 403].includes(status) && (
          <div className="error-infos">
            <VpButton
              variant="tertiary"
              size="small"
              onClick={() => setIsOpen(current => !current)}
              startSlot={(
                <VpIcon
                  name={isOpen ? 'chevron-down' : 'chevron-up'}
                />
              )}
            >
              {isOpen ? tDialog('NO_DISPLAY') : tDialog('DISPLAY')}
            </VpButton>
            {isOpen && (
              <>
                {!!status && (
                  <>
                    {tDialog('STATUS')}
                    {' '}
                    {status}
                  </>
                )}
                <br />
                {tDialog('DESCRIPTION')}
                {' '}
                {error['hydra:description'] || error.error_description || error.message}
                {' '}
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
